// localStorage can throw (private mode, a full quota, or not existing at
// all) — must never crash the app, only fail to persist.

export function readLocalStorage(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeLocalStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Doesn't persist, but the app keeps working — see the header comment above.
  }
}
